export class IconList {
    constructor() {
        var element = document.createElement("div");
        element.id = "icon-list";
        document.body.appendChild(element);
        for (var i = 1; i <= 866; ++i) {
            var entry = document.createElement("div");
            entry.classList.add("icon-list-entry", "icon-" + i);
            entry.title = i + "";
            element.appendChild(entry);
        }
    }
}